import { render, staticRenderFns } from "./novel_list.vue?vue&type=template&id=5c5f6b1b&scoped=true"
import script from "./novel_list.vue?vue&type=script&lang=js"
export * from "./novel_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f6b1b",
  null
  
)

export default component.exports